import { ImpersonationApi } from '@portal/pkg-api/admin'
import { AuthApiConfiguration } from '@portal/pkg-api/config'
import { ResumeApi as ResumeApiGen, ResumeRedeemRequest } from '@portal/pkg-api/gen/auth'
import { data } from '@portal/pkg-api/shared'
import { SELF_HANDLED_FAILURES } from './requestFailure'

export const ResumeApi = new ResumeApiGen(AuthApiConfiguration)

// Each caller decides what a failure means, so every request here passes SELF_HANDLED_FAILURES.
// Handles travel only in request bodies, never in a URL.

/** Logged in only. Extends the session, so call it only after user activity. */
export const fetchResumeCredentials = () =>
  data(ResumeApi.getResumeCredentials(SELF_HANDLED_FAILURES))

/** Called while logged out. */
export const fetchResumeStatus = (handle: string) =>
  data(ResumeApi.getResumeStatus({ handle }, SELF_HANDLED_FAILURES))

/**
 * Called while logged out. The org logo of the user who timed out, or undefined when there's none
 * or the request fails; the page then shows the usual logged-out logo.
 */
export async function fetchResumeLogo(handle: string): Promise<Blob | undefined> {
  try {
    const logo: unknown = await data(
      ResumeApi.getResumeLogo({ handle }, { ...SELF_HANDLED_FAILURES, responseType: 'blob' }),
    )
    return logo instanceof Blob && logo.size > 0 ? logo : undefined
  } catch {
    return undefined
  }
}

export const checkResume = (handle: string) =>
  data(ResumeApi.checkResume({ handle }, SELF_HANDLED_FAILURES))

export const redeemResume = (request: ResumeRedeemRequest) =>
  data(ResumeApi.redeemResume(request, SELF_HANDLED_FAILURES))

export const declineResumeImpersonation = (handle: string) =>
  ResumeApi.declineResumeImpersonation({ handle }, SELF_HANDLED_FAILURES).then(() => undefined)

/**
 * Starts impersonating the user again: the same call, permission check and audit trail as the
 * Users table's Impersonate. It applies to the whole session, so to every tab.
 */
export const resumeImpersonation = (userId: number) =>
  ImpersonationApi.impersonateUser(userId, SELF_HANDLED_FAILURES).then(() => undefined)
